import React from 'react';
import { Icon } from '../Icon/Icon.jsx';
import { BODY, ink } from '../../primitives.js';

const h = React.createElement;

const BT = { info: ['var(--blu-bg)', 'var(--blu-tx)', 'info'], success: ['var(--lime-bg)', 'var(--lime-tx)', 'circle-check'], warning: ['var(--gold-bg)', 'var(--gold-tx)', 'triangle-alert'], error: ['var(--coral-bg)', 'var(--coral-tx)', 'circle-alert'], offline: ['var(--inset)', 'var(--tx)', 'wifi-off'], locked: ['var(--inset)', 'var(--tx)', 'lock'] };

/**
 * Persistent message. Never auto-dismissed; errors clear when fixed.
 *
 * @param {object} p
 * @param {'info'|'success'|'warning'|'error'|'offline'|'locked'} [p.tone]
 * @param {React.ReactNode} [p.title]
 * @param {React.ReactNode} [p.children]
 * @param {React.ReactNode} [p.action]
 * @param {() => void} [p.onClose]
 * @param {React.CSSProperties} [p.style]
 */
export function Banner({ tone = 'info', title, children, action, onClose, style }) {
  const [bg, fg, ic] = BT[tone] || BT.info;
  return h('div', { role: tone === 'error' || tone === 'offline' ? 'alert' : 'status', className: 'gx-fade', style: { display: 'flex', alignItems: 'flex-start', gap: 12, padding: '12px 14px', background: bg, border: ink(2), borderRadius: 12, fontFamily: BODY, fontSize: 13, lineHeight: 1.45, color: 'var(--tx)', ...style } },
    h('span', { style: { color: fg, display: 'flex', paddingTop: 1 } }, h(Icon, { name: ic, size: 18 })),
    h('div', { style: { flex: 1, minWidth: 0 } }, title ? h('div', { style: { fontWeight: 800, color: fg } }, title) : null, children ? h('div', { style: { color: 'var(--tx2)', marginTop: title ? 2 : 0 } }, children) : null),
    action ? h('div', { style: { flex: 'none', alignSelf: 'center' } }, action) : null,
    onClose ? h('button', { type: 'button', onClick: onClose, 'aria-label': 'Dismiss', title: 'Dismiss', style: { border: 0, background: 'none', color: 'var(--tx2)', cursor: 'pointer', display: 'flex', padding: 2 } }, h(Icon, { name: 'x', size: 15 })) : null);
}
